import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { getCurrentSession, getLoginUrl } from '../api/auth';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * 进入 KFC 页面前校验 Kratos 会话；未登录则跳转 auth 登录页并带回 returnUrl。
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const session = await getCurrentSession();
        if (cancelled) return;
        if (!session) {
          const loginUrl = getLoginUrl();
          const returnUrl = encodeURIComponent(window.location.href);
          window.location.href = `${loginUrl}?returnUrl=${returnUrl}`;
          return;
        }
        setAuthenticated(true);
      } catch {
        if (!cancelled) {
          setAuthenticated(false);
        }
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (checking) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="正在验证身份..." />
      </div>
    );
  }

  if (!authenticated) {
    return null;
  }

  return <>{children}</>;
};

export default AuthGuard;
